import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionGame = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 5L18 8.4641V15.3923L12 18.8564L6 15.3923V8.4641L12 5Z" fill="currentColor" />
  </svg>,
  'TransactionGame'
);
